module.exports = __webpack_public_path__ + "media/images/visa-square-eef541198bc18110faebd38b7d74a57a.png";